module.exports = __webpack_public_path__ + "static/media/IndustryLeader008.d59b9170.png";